import mixpanel from 'mixpanel-browser'

export var userData = {}
export var ipRetrieved = false
export var ipServiceEndpoint = 'https://api.ipify.org?format=json'

export function resetUserData () {
  userData = {}
  return userData
}

export function identify (username, email) {
  Object.assign(userData, {
    username,
    '$email': email,
    '$name': username
  })

  // mixpanel-browser idiom: identify the distinct user, then set props on that profile
  // (the server SDK's people.set(distinctId, props) maps to identify(id) + people.set(props)).
  mixpanel.identify(username)
  mixpanel.people.set(userData)
}

export function getIp () {
  return new Promise((resolve, reject) => {
    if (ipRetrieved) {
      resolve(userData)
    } else {
      ipRetrieved = true
      // CP4.4: was Vue.http (vue-resource, removed) — a plain fetch for the ipify lookup.
      fetch(ipServiceEndpoint).then((response) => response.json()).then((ipData) => {
        ipRetrieved = true
        userData['$ip'] = ipData.ip
        resolve(userData)
      }).catch((e) => {
        reject(e)
      })
    }
  })
}
